var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstimateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4157 8.76142C17.6425 8.66161 17.9069 8.70531 18.0896 8.87279L23.0896 13.4561C23.3441 13.6894 23.3613 14.0847 23.128 14.3392C22.8948 14.5936 22.4994 14.6108 22.245 14.3776L18.2923 10.7543L18.2923 22.6668C18.2923 23.012 18.0125 23.2918 17.6673 23.2918C17.3221 23.2918 17.0423 23.012 17.0423 22.6668L17.0423 9.33351C17.0423 9.08565 17.1888 8.86122 17.4157 8.76142ZM14.334 8.70851C14.6792 8.70851 14.959 8.98833 14.959 9.33351L14.959 22.6668C14.959 22.9147 14.8125 23.1391 14.5857 23.2389C14.3588 23.3387 14.0944 23.295 13.9117 23.1276L8.91166 18.5442C8.65721 18.311 8.64002 17.9156 8.87327 17.6612C9.10651 17.4067 9.50187 17.3895 9.75632 17.6228L13.709 21.2461L13.709 9.33351C13.709 8.98833 13.9888 8.70851 14.334 8.70851Z",
    fill: "#9B7CC8",
    stroke: "#9B7CC8",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E8E1F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimateIcon);
export default __webpack_public_path__ + "static/media/estimate-Icon.b4ccbe4f655680d9c8268afbadd04c2d.svg";
export { ForwardRef as ReactComponent };